<template>
	<div class="video-control" ref="control" v-show="show">
		<div class="video-control-cover" @click="coverClick"></div>
		<div class="video-control-main" v-show="showMain">
			<div class="video-control-play"
				:class="{'video-control-pause': playing}"
				@click="play"></div>
			<div class="video-control-line"
				@touchstart="touchstart($event)"
				@touchmove="touchmove($event)"
				@touchend="touchend($event)"
				@mousedown="touchstart($event)"
				@mousemove="touchmove($event)"
				@mouseup="touchend($event)">
				<div class="video-control-line-box" ref="line">
					<div class="video-control-line-buffered"
            :style="{width: bufferedPercent}"></div><!-- 缓存 -->
					<div class="video-control-line-current"
            :style="{width: currentPercent}"></div><!-- 进度 -->
				</div>
			</div>
			<div class="video-control-time">
				<template v-if="live">{{currentTime | time}}</template>
				<template v-else>{{currentTime | time}}/{{duration | time}}</template>
			</div>
			<div class="video-control-fullscreen"
				v-if="showFull"
				@click="fullscreen"></div>
		</div>
	</div>
</template>

<script>
const double = value => (value < 10 ? '0' : '') + value // 补0

export default {
  props: [
    'currentTime', // 当前时间
    'buffered', // 缓冲时间
    'duration', // 总时长
    'playing', // 正在播放
    'showFull', // 是否展示全屏按钮
    'show', // 是否展示控制条
    'live', // 是否是直播
    'isAudio' // 是否是音频
  ],
  data () {
    return {
      timer: -1, // 显示倒计时
      touching: false, // 正在触摸时间条
      touchPercent: 0, // 正在触摸时进度百分比
      touchTime: 0, // 正在触摸时的时间长度
      showMain: true, // 是否展示控制条
      showMainTimer: -1, // 展示控制条定时器
      showMainInterval: 2500 // 控制条展示时间
    }
  },
  computed: {
    // 缓冲条长度百分比
    bufferedPercent () {
      if (!this.duration) return 0
      return (
        Math.min(100, Math.round(this.buffered / this.duration * 100)) + '%'
      )
    },
    // 播放进度百分比
    currentPercent () {
      if (!this.duration) return 0
      if (this.touchPercent) return this.touchPercent * 100 + '%'
      return (
        Math.min(100, Math.round(this.currentTime / this.duration * 100)) + '%'
      )
    }
  },
  methods: {
    // 播放按钮点击
    play () {
      this.$emit('play')
    },
    // 全屏点击
    fullscreen () {
      this.$emit('full')
      this.showControl()
    },
    // 获取进度条相关数据
    getLine (event) {
      let clientX = event.clientX
      if (event.touches && event.touches.length) {
        clientX = event.touches[0].pageX
      }

      const line = this.$refs.line

      const bound = line.getBoundingClientRect()

      let percent = (clientX - bound.left) / bound.width
      if (percent > 1) {
        percent = 1
      } else if (percent < 0) {
        percent = 0
      }

      let time = percent * this.duration

      return {
        clientX,
        line,
        bound,
        percent,
        time
      }
    },
    // 播放条拖动1
    touchstart (event) {
      if (this.live) {
        return false
      }

      const line = this.getLine(event)
      this.touching = true
      this.touchPercent = line.percent
      this.touchTime = line.time
      // this.currentTime = line.time

      this.showControl(false)
    },
    // 播放条拖动2
    touchmove (event) {
      if (this.touching) {
        const line = this.getLine(event)
        this.touchPercent = line.percent
        this.touchTime = line.time
        // this.currentTime = line.time
      }
    },
    // 播放条拖动3
    touchend (event) {
      if (this.touching) {
        this.$emit('seek', {
          time: this.touchTime
        })
        this.touching = false
        this.touchPercent = 0
        this.touchTime = 0

        this.showControl()
      }
    },
    // 遮罩点击
    coverClick () {
      this.showControl()
    },
    // 显示控制条(是否一段时间后隐藏, 默认是)
    showControl (ifHideLater = true) {
      this.showMain = true
      clearTimeout(this.showMainTimer)
      if (ifHideLater && !this.isAudio) {
        // 播放音频时不隐藏播放条
        this.showMainTimer = setTimeout(() => {
          this.showMain = false
        }, this.showMainInterval)
      }
    },
    hideControl () {
      this.showMain = false
      clearTimeout(this.showMainTimer)
    }
  },
  filters: {
    // 时间过滤器
    time (value) {
      let second = double(parseInt(value % 60))
      let minute = double(parseInt(value / 60))
      if (isNaN(second)) second = '00'
      if (isNaN(minute)) minute = '00'
      return `${minute}:${second}`
    }
  },
  mounted () {
    this.showControl()
  }
}
</script>

<style lang="scss">
@charset "utf-8";
@import "../../../style/main";

$global-width: 750;

.video-control {
  @include afull();
  z-index: 5;
  &-cover {
    @include afull();
  }
  &-main {
    @include absolute("blw");
    @include height(rem(76));
    // background-color: rgba(#000, .45);
    background-color: #333;
    display: flex;
  }
  &-play {
    @include square(rem(76));
    position: relative;
    &:before {
      content: "";
      display: block;
      @include atl(rem(23), rem(28));
      @include square(rem(25), rem(28.5));
      background-size: 100% 100%;
      background-image: url("./img/play.png?__inline");
    }
  }
  &-pause {
    &:before {
      // @include square(rem(26), rem(34));
      background-image: url("./img/pause.png?__inline");
    }
  }
  &-line {
    flex: 1;
    &-box {
      @include square(94%, rem(8));
      margin-top: rem(34);
      margin-left: rem(6);
      background-color: rgba(#fff, 0.3);
      border-radius: rem(3);
      position: relative;
    }
    &-buffered {
      display: block;
      @include absolute("tlwh");
      background-color: rgba(#fff, 0.3);
      border-radius: rem(3);
    }
    &-current {
      display: block;
      @include absolute("tlwh");
      border-radius: rem(3);
      background-color: #ecd228;
      &:after {
        content: "";
        display: block;
        @include square(rem(10));
        background-color: #ecd228;
        border: rem(6) solid #ffffff;
        border-radius: 50%;
        @include atr(- rem(7), - rem(11));
      }
    }
  }
  &-time {
    font-size: rem(20);
    color: #fff;
    &:last-child {
      margin-right: rem(20);
    }
  }
  &-fullscreen {
    @include square(rem(76));
    position: relative;
    &:before {
      content: "";
      display: block;
      @include atl(rem(23), rem(28));
      @include square(rem(25), rem(28.5));
      background-size: 100% 100%;
      background-image: url("./img/fullscreen.png?__inline");
      // #{$fullscreen} & {
      // 	background-image: url('./img/fullscreen-exit.png?__inline');
      // }
    }
  }
}

$global-width: 720;
</style>
